export default class ProductPricing {
  [key: string]: string | number | boolean;
  pachat: string = "";
  pvente: string = "";
  marge: string = "";
  majoration: string = "";
  isDeduction: boolean = true;
  isTaxable: boolean = true;
}
